
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[id]",
      function () {
        return require("private-next-pages/building/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[id]"])
      });
    }
  